var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-text",
    class: _vm.printRead ? 'm-l-5' : ''
  }, [_vm.textType === 'html' ? _c('div', _vm._g({
    domProps: {
      "innerHTML": _vm._s(_vm.textContent)
    }
  }, _vm.$listeners)) : _c('text-type', _vm._g({
    attrs: {
      "text-type": _vm.textType,
      "text-content": _vm.textContent
    }
  }, _vm.$listeners)), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };